<div class="mb-1">
  <nb-checkbox (checkedChange)="zmienWidocznoscWykresu($event)">{{ 'etykieta.pokaz-wykres' | translate }}</nb-checkbox>
</div>
<div [hidden]="!chart || ukryjWykres" class="chart-container">
  <canvas id="chart">{{ chart }}</canvas>
</div>